// Historical display must never fall back to the account's current profile.
export function paperCreator(paper) {
  return (paper && paper.creatorSnapshot) || {};
}

export function paperCreatorName(paper) {
  const creator = paperCreator(paper);
  return [creator.firstName, creator.lastName].filter(Boolean).join(" ");
}

export function savedApprovalResult(response) {
  const result = response.data.response;
  if (!result || !result.approval) {
    throw new Error("The server did not return the saved approval.");
  }
  return result;
}
